


import axios from '../ajax'

/**
 *  名医科普接口
 */

// 获取视频、语音列表
export const finddoctorTree = (data) => {
  return axios({
    url:'/article/doctor/'+data.doctorId+'/'+data.type+'/'+data.page+'/'+data.size,
    method:'get',
    data
  })
}
export const findVideoTree = (data) => {
  return axios({
    url:'/article/home/type/'+data.type+'/'+data.page+'/'+data.size,
    method:'get',
    data
  })
}

// article/home
export const findallVideoTree = () => {
  return axios({
    url:'/article/home',
    method:'get',
  })
}
// 获取医生列表
export const findDoctorTree = (params) => {
  return axios({
    url:'/article/listDoctor'+'/'+params.page+'/'+params.size,
    method:'get',
  })
}

// 获取轮播图
export const findSwiperTree = (params) => {
  return axios({
    url:'/article/listSlide'+'/'+params.type,
    method:'get'
  })
}

// 获取视频详情
export const findVideoShow = (params) => {
  return axios({
    url:'/article/getDetail'+'/'+params.id,
    method:'get',
  })
}

// 获取推荐列表
export const findGoodList = (params) => {
  return axios({
    url:'/article/getRecommend'+'/'+params.id+'/'+params.size,
    method:'get',
  })
}

// 获取医生详情
export const findDoctorShow = (params) => {
  return axios({
    url:'/article/detailDoctor'+'/'+params.doctorId,
    method:'get',
  })
}

// 详情热点关注
export const findDetailsHotlist = (params) => {
  return axios({
    url:'/article/hot/type/'+params.doctorId+'/'+params.type,
    method:'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/mykp_api/home.js